import { styled } from 'styled-components';

import { colorMap } from '../../constants/colors';
import type { Color } from '../../store/store';

const Wrapper = styled.div<{ $color: string; $selected: boolean }>`
  width: ${(props) => {
    return props.$selected ? '16px' : '10px';
  }};
  height: ${(props) => {
    return props.$selected ? '16px' : '10px';
  }};
  border-radius: ${(props) => {
    return props.$selected ? '8px' : '5px';
  }};
  background-color: ${(props) => props.$color};
`;

type Props = {
  color: Color;
  onClick: (color: Color) => void;
  selected: boolean;
};

export const ColorIcon = (props: Props) => {
  const { color, onClick, selected } = props;

  const onClickColor = () => {
    onClick(color);
  };

  return <Wrapper $color={colorMap[color.color]} $selected={selected} onClick={onClickColor} />;
};
